import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import NavigationLinks from "./NavigationLinks";
import CalendarButton from "../calendar/CalendarButton";
import LanguageSwitcher from "./LanguageSwitcher";
import "./NavBar.css";

function NavBar(props) {
  const location = useLocation();
  const navRef = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAboutMenuOpen, setIsAboutMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsAboutMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!navRef.current?.contains(event.target)) {
        setIsAboutMenuOpen(false);
      }
    };

    document.addEventListener("pointerdown", handlePointerDown);

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((currentValue) => !currentValue);
  };

  const toggleAboutMenu = () => {
    setIsAboutMenuOpen((currentValue) => !currentValue);
  };

  const closeMenus = () => {
    setIsMobileMenuOpen(false);
    setIsAboutMenuOpen(false);
  };

  return (
    <>
      {/* Banner image at the top */}
      <Link to="/aboutUs">
        <img
          src="/images/banner.png"
          alt="Banner"
          className="top-banner"
          style={{ cursor: "pointer" }}
        />
      </Link>

      {/* NavBar below the banner */}
      <header className="navBar">
        <div className="container" ref={navRef}>
          <div className="navBar-inner">
            <div className="navBar-mainRow">
              <button
                type="button"
                className={`navBar-menuButton${isMobileMenuOpen ? " is-open" : ""}`}
                aria-expanded={isMobileMenuOpen}
                aria-controls="primary-navigation"
                aria-label="Toggle navigation menu"
                onClick={toggleMobileMenu}
              >
                <span />
                <span />
                <span />
              </button>

              <div className="navBar-linksDesktop">
                <NavigationLinks
                  location={location}
                  userType={props.userType}
                  isAboutMenuOpen={isAboutMenuOpen}
                  toggleAboutMenu={toggleAboutMenu}
                  closeMenus={closeMenus}
                />
              </div>

              <div className="navBar-actions">
                <CalendarButton />
                <LanguageSwitcher />
              </div>
            </div>

            <div
              id="primary-navigation"
              className={`navBar-mobilePanel${isMobileMenuOpen ? " is-open" : ""}`}
            >
              <NavigationLinks
                location={location}
                userType={props.userType}
                isAboutMenuOpen={isAboutMenuOpen}
                toggleAboutMenu={toggleAboutMenu}
                closeMenus={closeMenus}
                isMobile
              />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default NavBar;
